import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:8000/api' : 'https://www.adabocash.com/api'),
  withCredentials: true,
  headers: {
    common: { 'X-Requested-With': 'XMLHttpRequest' },
    post: { 'Content-Type': 'application/json' },
    put: { 'Content-Type': 'application/json' },
    patch: { 'Content-Type': 'application/json' },
  },
});

API.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry && originalRequest.url !== '/token/' && originalRequest.url !== '/token/refresh/' && originalRequest.url !== '/exchange-rate/' && originalRequest.url !== '/logout/') {
      originalRequest._retry = true;
      try {
        console.log('Attempting token refresh...');
        await API.post('/token/refresh/', {});
        console.log('Token refresh successful, retrying original request.');
        return API(originalRequest);
      } catch (err) {
        console.error('Token refresh failed, clearing auth cookies and redirecting to login:', err);
        try {
          await API.post('/logout/');
        } catch (logoutErr) {
          console.error('Error during logout after token refresh failure:', logoutErr);
        }
        if (window.location.pathname !== '/login') {
            window.location.href = '/login';
        }
        return Promise.reject(err);
      }
    }
    if (originalRequest.url === '/token/refresh/' && error.response?.status === 401) {
        console.error('Refresh token endpoint returned 401. Clearing auth cookies and redirecting to login.');
        try {
          await API.post('/logout/');
        } catch (logoutErr) {
          console.error('Error during logout after refresh token failure:', logoutErr);
        }
        if (window.location.pathname !== '/login') {
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default API; 